export const IDEA = 'idea'
export const PREPARATION = 'preparation'
export const EXECUTION = 'execution'
export const IMPLEMENTATION = 'implementation'
export const STOPPED = 'stopped'

export const STATES = [
    IDEA,
    PREPARATION,
    EXECUTION,
    IMPLEMENTATION,
    STOPPED
]

export const STATES_SORT = {
    [IDEA]: 'a',
    [PREPARATION]: 'b',
    [EXECUTION]: 'c',
    [IMPLEMENTATION]: 'd',
    [STOPPED]: 'e'
}
